// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { GraphQLAuthMode } from '@aws-amplify/core/dist/esm/libraryUtils';

export const environment: any = {
  version: require('../../package.json').version,
  production: true,
  name: 'PROD',
  prefixVersion: '',
  locale: 'en',
  homeRoot: '/dashboard',
  providers: {
    api: {
      url: 'https://api.saesl.mobile.thelogchain.com/api',
      auth: {
        type: 'Bearer',
      },
    },
  },
  GRAFANA: {
    BASE_URL: 'https://demo.saesl.mobile.thelogchain.com/grafana',
    DASHBOARD_UID: 'advlvtb',
    DASHBOARD_SLUG: 'logchain-pmo-operations-dashboard-saesl-prod',
  },
  AWS_CONFIG: {
    Auth: {
      Cognito: {
        userPoolId: 'ap-southeast-1_87WuiLw5f',
        userPoolClientId: '36e743m4dvedp1g128e9iffj3p',
        identityPoolId: 'ap-southeast-1:22f54b70-a8ff-47a6-b4c8-212c0f08c5b9',
        loginWith: {
          oauth: {
            userPoolClientIdMS: '4rgotkgvtrh6g5ei4r73k8eqph',
            domain: 'logchain-microsoft.auth.ap-southeast-1.amazoncognito.com',
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: ['https://saesl.thelogchain.com/'],
            redirectSignOut: ['https://saesl.thelogchain.com/'],
            responseType: 'code' as const,
            msClientID: '718cf9a6-a569-413e-8bfe-2e9991db442b',
            msRedirectUrl:
              'https://saesl.thelogchain.com/auth/microsoft-callback',
          },
        },
      },
    },
    Storage: {
      S3: {
        bucket: 'logchain-saesl-prod',
        region: 'ap-southeast-1',
      },
    },
    API: {
      GraphQL: {
        endpoint:
          'https://hy55oyr5eve5liptu6swehahde.appsync-api.ap-southeast-1.amazonaws.com/graphql',
        region: 'ap-southeast-1',
        defaultAuthMode: 'userPool' as GraphQLAuthMode,
      },
    },
  },
  google_api_key: 'AIzaSyD1upPg36BJSXySxBF-0vOHjY0sUpS8t_E',
  host: 'https://saesl.thelogchain.com',
  firebase: {
    apiKey: 'AIzaSyD_Sa3uVPi8tplwkY8KXfNrbdqdPYd-n6Q',
    authDomain: 'lc-dev-be9e8.firebaseapp.com',
    projectId: 'lc-dev-be9e8',
    databaseURL: 'https://lc-dev-be9e8.firebaseio.com',
    storageBucket: 'lc-dev-be9e8.appspot.com',
    messagingSenderId: '493108013284',
    appId: '1:493108013284:web:f6c05f1c0ac3d6fe0164f1',
    measurementId: 'G-LLZ37JMSHC',
  },
  MS_CONFIG: {
    clientId: '3e8dbfdd-5176-484e-81b6-97e5879108e4',
    tenantId: '064f1d90-1b5c-4c16-8b7f-86212c059adb',
  },
  LANGUAGE: {
    Default: 'en',
    Support: ['en', 'es', 'ja', 'zh'],
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

